import React from "react";
import { Card, Input, List, Checkbox, Typography, Empty, notification } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { updateShowChecklistSettings } from "../../api/checklists";

const { Text } = Typography;

const FieldVisibilitySettings = ({ 
  editingChecklist, 
  setEditingChecklist, 
  checklists, 
  selectedStatus, 
  cfsInStatus, 
  showSettingsCFSearch, 
  setShowSettingsCFSearch 
}) => {
  const getAvailableFieldsForChecklist = () => {
    if (editingChecklist.parent) {
      const parentChecklist = checklists.find(c => c.id === editingChecklist.parent);
      const parentFields = parentChecklist?.custom_fields || [];
      const ownFields = editingChecklist.custom_fields || [];
      
      const allAvailableFields = [...ownFields];
      parentFields.forEach(parentField => {
        if (!allAvailableFields.some(field => field.id === parentField.id)) {
          allAvailableFields.push({
            ...parentField,
            isFromParent: true,
            displayName: `[${parentChecklist.name}] ${parentField.name}`
          });
        }
      });
      
      return allAvailableFields;
    } else {
      return cfsInStatus.filter(cf => !editingChecklist.custom_fields.map(ecf => ecf.id).includes(cf.id));
    }
  };

  const filteredCfsInStatus = getAvailableFieldsForChecklist()
    .filter(cf => cf.name.toLowerCase().includes(showSettingsCFSearch.toLowerCase()));

  return (
    <Card title="Отображать при выбранном поле" size="small" style={{ marginBottom: 16 }}>
      <Input
        prefix={<SearchOutlined />}
        value={showSettingsCFSearch}
        onChange={(e) => setShowSettingsCFSearch(e.target.value)}
        placeholder="Поиск полей"
        style={{ marginBottom: 16 }}
      />
      
      {filteredCfsInStatus.length > 0 ? (
        <List
          dataSource={filteredCfsInStatus}
          style={{ 
            maxHeight: '250px', 
            overflowY: 'auto',
            border: '1px solid #f0f0f0',
            borderRadius: '4px'
          }}
          renderItem={cf => (
            <List.Item>
              <Checkbox
                checked={editingChecklist.show_settings?.cfs_selected?.includes(cf.id) || false}
                onChange={(e) => {
                  const belongsToCurrentChecklist = editingChecklist.custom_fields.some(ecf => ecf.id === cf.id);
                  
                  let belongsToParentChecklist = false;
                  if (editingChecklist.parent) {
                    const parentChecklist = checklists.find(c => c.id === editingChecklist.parent);
                    belongsToParentChecklist = parentChecklist?.custom_fields?.some(pcf => pcf.id === cf.id) || false;
                  }
                  
                  if (!belongsToCurrentChecklist && !belongsToParentChecklist && editingChecklist.parent) {
                    notification.error({
                      message: 'Ошибка',
                      description: 'Невозможно настроить видимость поля из другого чеклиста',
                      placement: 'bottomRight'
                    });
                    return;
                  }

                  const csfSelected = e.target.checked
                    ? [...(editingChecklist.show_settings?.cfs_selected || []), cf.id]
                    : editingChecklist.show_settings?.cfs_selected?.filter(id => id !== cf.id);
                  
                  const updatedSettings = {
                    ...editingChecklist.show_settings,
                    cfs_selected: csfSelected
                  };
                  
                  setEditingChecklist({
                    ...editingChecklist,
                    show_settings: updatedSettings
                  });
                  
                  updateShowChecklistSettings(selectedStatus.amo_status_id, editingChecklist.id, csfSelected);
                }}
              >
                {cf.displayName || cf.name}
                {cf.isFromParent && (
                  <Text type="secondary" style={{ marginLeft: 8 }}>
                    (из родительского)
                  </Text>
                )}
              </Checkbox>
            </List.Item>
          )}
        />
      ) : (
        <Empty description="Нет доступных полей" />
      )}
    </Card>
  );
};

export default FieldVisibilitySettings; 